module.exports = __webpack_public_path__ + "sourcesanspro-light.7951903bff82a82e7cde.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/fonts/sourcesanspro/sourcesanspro-light.woff
// module id = ../../../../../src/fonts/sourcesanspro/sourcesanspro-light.woff
// module chunks = 2